module.exports = __webpack_public_path__ + "assets/img/campaign-image-4.4606baf5.png";